import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function Inbox(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.5 3.5h13a2 2 0 012 2v13a2 2 0 01-2 2h-13a2 2 0 01-2-2v-13a2 2 0 012-2zm0 1a1 1 0 00-1 1v13a1 1 0 001 1h13a1 1 0 001-1v-13a1 1 0 00-1-1h-13z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.5 14h-4v-1h4c.844 0 1.43.679 1.663 1.302.109.294.283.589.557.81.268.215.666.388 1.28.388s1.012-.173 1.28-.389c.274-.22.448-.515.557-.809.232-.623.82-1.302 1.663-1.302h4v1h-4c-.261 0-.572.238-.725.65a2.844 2.844 0 01-.869 1.24c-.462.372-1.086.61-1.906.61-.82 0-1.444-.238-1.906-.61a2.843 2.843 0 01-.869-1.24c-.153-.412-.464-.65-.725-.65z",
    clipRule: "evenodd"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Inbox);
export default ForwardRef;